<template>
    <v-form
        data-vv-scope="newPersonEmergencyContactForm"
    >
        <v-layout wrap>
            <v-flex
                md12
                sm12
                xs12
            >
                <v-text-field
                    :error-messages="newPersonPhoneNumberContactNumberErrors"
                    @blur="$v.newPersonPhoneNumberContactNumber.$touch()"
                    @input="$v.newPersonPhoneNumberContactNumber.$touch()"

                    label="Contact Number"
                    type="text"
                    v-model="newPersonPhoneNumberContactNumber"
                />
            </v-flex>
            <v-flex
                md12
                sm12
                xs12
            >
                <v-select
                    :error-messages="newPersonPhoneNumberTypeErrors"
                    :items="phoneNumberTypeList"
                    @blur="$v.newPersonPhoneNumberType.$touch()"
                    @input="$v.newPersonPhoneNumberType.$touch()"

                    label="Type"
                    type="text"
                    v-model="newPersonPhoneNumberType"
                />
            </v-flex>
            <v-flex
                md12
                sm12
                xs12
            >
                <v-select
                    :error-messages="newPersonPhoneNumberCategoryErrors"
                    :items="phoneNumberCategoryList"
                    @blur="$v.newPersonPhoneNumberCategory.$touch()"
                    @input="$v.newPersonPhoneNumberCategory.$touch()"

                    label="Category"
                    type="text"
                    v-model="newPersonPhoneNumberCategory"
                />
            </v-flex>
        </v-layout>
    </v-form>
</template>

<script>
    import {mapGetters} from "vuex";
    import {helpers, required} from 'vuelidate/lib/validators'
    import {SET_NEW_PERSON_FORM_SECTION_STATE, UPDATE_NEW_PERSON} from "@/store/person/mutations";
    import {FETCH_PERSONNEL_COUNTRY_LIST} from "../../../store/personnel_country/actions";

    // eslint-disable-next-line
    const phone = helpers.regex('alpha', /^(\+\s?)?((^\+.*)\(\+?\d+([\s\-\.]?\d+)?\)|\d+)([\s\-\.]?(\(\d+([\s\-\.]?\d+)?\)|\d+))*(\s?(x|ext\.?)\s?\d+)?$/);

    export default {
        name: "NewPersonPhoneNumber",

        validations: {
            newPersonPhoneNumberContactNumber: {
                required,
                phone
            },

            newPersonPhoneNumberType: {required},
            newPersonPhoneNumberCategory: {required},
        },

        computed: {
            newPersonPhoneNumberContactNumber: {
                get() {
                    return this.$store.state.person.newPerson.phoneNumbers[0].contactNumber;
                },
                set(value) {
                    let data = {};
                    data.objectKey = 'phoneNumbers';
                    data.key = 'contactNumber';
                    data.value = value;
                    this.$store.commit(UPDATE_NEW_PERSON, data);
                }
            },

            newPersonPhoneNumberContactNumberErrors() {
                const errors = [];
                if (!this.$v.newPersonPhoneNumberContactNumber.$dirty) {
                    return errors;
                }
                if (!this.$v.newPersonPhoneNumberContactNumber.required) {
                    errors.push('Required.');
                }
                if (!this.$v.newPersonPhoneNumberContactNumber.phone) {
                    errors.push('Must be a valid phone number.');
                }

                return errors
            },

            newPersonPhoneNumberType: {
                get() {
                    return this.$store.state.person.newPerson.phoneNumbers[0].type;
                },
                set(value) {
                    let data = {};
                    data.objectKey = 'phoneNumbers';
                    data.key = 'type';
                    data.value = value;
                    this.$store.commit(UPDATE_NEW_PERSON, data);
                }
            },

            newPersonPhoneNumberTypeErrors() {
                const errors = [];
                if (!this.$v.newPersonPhoneNumberType.$dirty) return errors;
                !this.$v.newPersonPhoneNumberType.required && errors.push('Required.');
                return errors
            },

            newPersonPhoneNumberCategory: {
                get() {
                    return this.$store.state.person.newPerson.phoneNumbers[0].category;
                },
                set(value) {
                    let data = {};
                    data.objectKey = 'phoneNumbers';
                    data.key = 'category';
                    data.value = value;
                    this.$store.commit(UPDATE_NEW_PERSON, data);
                }
            },

            newPersonPhoneNumberCategoryErrors() {
                const errors = [];
                if (!this.$v.newPersonPhoneNumberCategory.$dirty) return errors;
                !this.$v.newPersonPhoneNumberCategory.required && errors.push('Required.');
                return errors
            },

            ...mapGetters(
            [
                "phoneNumberTypeList",
                "phoneNumberCategoryList"
            ]
            ),
        },

        mounted() {
            this.fetchPersonnelCountryList();
        },

        methods: {
            fetchPersonnelCountryList() {
                this.$store.dispatch(FETCH_PERSONNEL_COUNTRY_LIST);
            },

            validate() {

                this.$v.$touch();

                let formState = false;


                if (this.$v.$anyDirty === false) {
                    formState = 'clean';
                } else {
                    if (this.$v.$anyError === true) {
                        formState = 'error';
                    } else {
                        formState = 'complete';
                    }
                }
                this.$store.commit(SET_NEW_PERSON_FORM_SECTION_STATE, {section: 'phoneNumber', state: formState});
            },
        },
    }
</script>

<style scoped>

</style>
